import classNames from 'classnames';
import React, { memo, useCallback, useMemo, useState } from 'react';

import AnimatedSpinnerComponent from 'common/components/AnimatedSpinner/AnimatedSpinner.component';

import { useBowser } from 'common/hooks';
import svgIcons from 'common/svgIcons';

import SvgIconUrl from '../SvgIconUrl/SvgIconUrl.component';
import './index.css';

const SplashScreenComponent: React.FC<React.PropsWithChildren<{ isLoading?: boolean }>> = ({ isLoading = false }) => {
  const { isMobile } = useBowser();
  const [spinnerAnimationStopped, setSpinnerAnimationStopped] = useState(false);

  const splashScreenClassNames = classNames({
    'splash-screen': true,
    'splash-screen--hidden': isMobile ? !isLoading : spinnerAnimationStopped && !isLoading,
  });

  const onStopped = useCallback(() => {
    setSpinnerAnimationStopped(true);
  }, []);

  const isTestEnvironment = useMemo(() => localStorage.getItem('runningPlaywright'), []);

  if (window.__TEST__ || window.location.hostname === 'localhost' || isTestEnvironment) return null;

  return (
    <div className={splashScreenClassNames}>
      {isMobile ? (
        <SvgIconUrl style={{ width: '100%', height: '8vh' }} symbol={svgIcons.LogoDark()} />
      ) : (
        <AnimatedSpinnerComponent isLoaded={!isLoading} onStopped={onStopped} />
      )}
    </div>
  );
};

export default memo(SplashScreenComponent);
